import { render, staticRenderFns } from "./PreparationVisas.vue?vue&type=template&id=3ef35e0e&"
import script from "./PreparationVisas.vue?vue&type=script&lang=js&"
export * from "./PreparationVisas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports